<template>
    <b-tab @click="showAssinatura = false">
        <template #title><i class="mdi mdi-bank-outline"></i> Unidade(s)</template>
        <div>
            <load v-if="loadsending" mode="table" />
            <form v-else @submit.prevent="$emit('add'); loadsending = true" ref="addItem">
                <div class="col-md-12 d-flex justify-content-between mt-3 px-0">
                    <h4>Informação da(s) Unidade(s) - Vínculos</h4>
                    <a class="btn btn-primary btn-sm mr-0" @click="$bvModal.show('novo-vinculo-unidade')"
                        v-if="$store.state.user.id != item.user_id">
                        <i class="mdi mdi-link-variant"></i>
                        Vincular técnico a outra unidade
                    </a>
                </div>
                <!-- Formulário para primeira unidade (quando não há vínculos) -->
                <div class="row" v-if="unidades_tecnico.length <= 0">
                    <form-select grid="6" v-model="item.unidade_id" :itens="unidades" :loading="loadingSearchUnidade"
                        :disabled="true" :required="true" placeholder="Pesquise o nome de uma Unidade."
                        label="Unidade" />
                    <form-select grid="6" v-model="item.role_id" :itens="roles" :required="true"
                        placeholder="Selecione uma Função" label="Função na Unidade/Sistema"
                        :disabled="disabled_role" />
                    <form-select grid="4" v-model="item.regime_trabalho" :itens="$root.arrays.regimeTrabalhoTecnicos"
                        placeholder="Selecione" label="Regime de Trabalho" />
                    <form-calendar v-model="item.data_admissao" grid="4" label="Data de Vinculação" />
                    <form-calendar v-model="item.data_desvinculacao" grid="4" label="Data de Desvinculação" />
                </div>

                <!-- Abas para vínculos ativos e inativos -->
                <b-tabs v-else content-class="mt-3" nav-class="nav-tabs-custom">
                    <!-- Aba Vínculos Ativos -->
                    <b-tab>
                        <template #title>
                            <i class="fas fa-check-circle text-success mr-1"></i>
                            Vínculos Ativos 
                            <span class="badge badge-success ml-1">{{ vinculosAtivos.length }}</span>
                        </template>
                        
                        <div class="row" v-if="vinculosAtivos.length <= 0">
                            <div class="col-12 text-center py-4">
                                <i class="fas fa-info-circle text-muted fa-2x mb-2"></i>
                                <p class="text-muted">Nenhum vínculo ativo encontrado</p>
                            </div>
                        </div>
                        
                        <div class="mb-3" v-for="(unidade, i) in vinculosAtivos" :key="'ativo-' + i">
                            <NovaUnidade :unidade="unidade" :unidades="unidades" :roles="roles" :index="i"
                                :disabled-role="disabled_role" @remover="removerUnidade" />
                        </div>
                    </b-tab>

                    <!-- Aba Vínculos Inativos -->
                    <b-tab>
                        <template #title>
                            <i class="fas fa-times-circle text-danger mr-1"></i>
                            Vínculos Inativos 
                            <span class="badge badge-danger ml-1">{{ vinculosInativos.length }}</span>
                        </template>
                        
                        <div class="row" v-if="vinculosInativos.length <= 0">
                            <div class="col-12 text-center py-4">
                                <i class="fas fa-info-circle text-muted fa-2x mb-2"></i>
                                <p class="text-muted">Nenhum vínculo inativo encontrado</p>
                            </div>
                        </div>
                        
                        <div class="mb-3" v-for="(unidade, i) in vinculosInativos" :key="'inativo-' + i">
                            <NovaUnidade :unidade="unidade" :unidades="unidades" :roles="roles" :index="i"
                                :disabled-role="disabled_role" @remover="removerUnidade" />
                        </div>
                    </b-tab>
                </b-tabs>
                
                <div class="float-right mt-3" v-if="showAssinatura == false">
                    <router-link class="btn btn-default" to="/dashboard/tecnicos">
                        <i class="mdi mdi-arrow-left" />
                    </router-link>
                    <button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
                        <i class="mdi mdi-content-save" /> {{ $t("Salvar") }}
                    </button>
                    <br>
                    <a 
                        class="router-link-exact-active active" 
                        @click="$bvModal.show('historico-vinculo-unidade')"
                    >
                        <i class="fas fa-history"></i>
                        Histórico de Vínculo(s)
                    </a>
                </div>
            </form>
            <HistoricoVinculo
                :unidadesTecnico="unidadesTecnico"
            />
            <NovoVinculo
                :unidades="unidades"
                :roles="roles"
                :index="0"
            />
        </div>
    </b-tab>
</template>
<script>
import NovaUnidade from "../NovaUnidade";
import HistoricoVinculo from '../HistoricoVinculo.vue';
import NovoVinculo from "../NovoVinculo.vue";
export default {
    components: {
        NovaUnidade,
        HistoricoVinculo,
        NovoVinculo
    },
    props: {
        item: {
            type: Object,
            default: () => { },
        },
        unidadesTecnico: {
            type: Array,
            default: () => { },
        },
        roles: {
            type: Array,
            default: () => [],
        },
        unidades: {
            type: Array,
            default: () => [],
        },
        passwordInput: {
            type: String,
            default: null,
        },
        showAssinatura: {
            type: Boolean,
            default: false,
        },
        disabled_role: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            progressCompleted: 0,
            unidades_tecnico: [],
            loadingSearchUnidade: false,
            loadsending: false,
            add_unidade: false,
        };
    },
    mounted() {
        this.unidades_tecnico = this.unidadesTecnico;
    },
    computed: {
        vinculosAtivos() {
            return this.unidades_tecnico.filter(unidade => unidade.status === 1);
        },
        vinculosInativos() {
            return this.unidades_tecnico.filter(unidade => unidade.status !== 1);
        }
    },
    methods: {
        removerUnidade(index) {
            this.unidades_tecnico.splice(index, 1);
        },
        addNewUnidade() {
            let size = this.item.unidades != null ? this.item.unidades.length : 0;
            if (size == 0) {
                this.unidades_tecnico[0] = {
                    funcao_unidade: this.item.role_id,
                    regime_trabalho: this.item.regime_trabalho,
                    carga_horaria: this.item.carga_horaria,
                    data_admissao: this.item.data_admissao,
                    unidade_id: this.item.unidade_id,
                    data_desvinculacao: this.item.data_desvinculacao,
                };
            }
            this.unidades_tecnico.push({
                funcao_unidade: null,
                regime_trabalho: null,
                carga_horaria: null,
                data_admissao: null,
                unidade_id: null,
                data_desvinculacao: null,
            });
            // this.unidades_tecnico = this.unidades_tecnico.reverse()
        },
        verificarStatus(status) {
            this.statusAtual = status;

            const result = this.status_item.filter((item) => item.id == status);
            if (result[0].final == 1) {
                //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
    },
};
</script>
